import { ErrorResponse } from "@gtpl/shared-models/common-models";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { Injectable } from "@nestjs/common";
import appSettings from "apps/services/config";
import { getManager } from "typeorm";
import { ContainerLogBookIdRequestDto } from "./dto/container-log-book-id.request.dto";
import { LogBookItemsRepository } from "./repository/log-book-items.repository";

@Injectable()
export class LogBookItemsService {
    constructor(private repository: LogBookItemsRepository) { }

    async getLogBookItemDetails(req:ContainerLogBookIdRequestDto): Promise<CommonResponse> {
        const manager = getManager();  
        try{
            let query = "select lb.log_book_item_id AS logBookItemId, lb.container_log_book_id AS containerLogBookId, lb.row AS row, lb.sale_order_item_id AS saleOrderItemId, lb.cartons AS cartons, lb.brand_id AS brandId,sk.variant_code AS variant,mb.brand_name AS brandName from "+appSettings.logistics_db+".log_book_items lb left join "+appSettings.sales_db+".sale_order_items si on si.sale_order_item_id = lb.sale_order_item_id left join "+appSettings.masters_db+".sku_codes sk on sk.sku_code_id = si.varient_id left join "+appSettings.masters_db+".master_brands mb on mb.master_brand_id = lb.brand_id where container_log_book_id = " + req.containerLogBookId;
            let queryResult = await manager.query(query)
            if (queryResult) {
            return new CommonResponse(true, 1001, "Container Log Saved Successfully. ", queryResult);
            } else {
                return new CommonResponse(false,11106,'No Data Found');
            }
        }
        catch(error){  
            await manager.release(); 
            console.log(error); 
        }
    }
}